export enum EngagementChartTypeEnum {
	TotalCount = 'Total',
	Provider = 'Provider',
	Program = 'Program',
	Language = 'Language',
	Service = 'Service',
	School = 'School',
}

export const EngagementChartTypeArray = [
    EngagementChartTypeEnum.TotalCount,
    EngagementChartTypeEnum.Provider,
    EngagementChartTypeEnum.Program,
    EngagementChartTypeEnum.Language,
    EngagementChartTypeEnum.Service,
    EngagementChartTypeEnum.School,
];

